export enum CalendarStatus {
  Scheduled = 'scheduled',
  Waiting = 'waiting',
  Approved = 'approved',
  Rejected = 'rejected',
  DidntPublishOnTime = 'didntPublishOnTime',
  Successfully = 'successfully',
}
